// components/CustomTooltip.tsx
import React from "react";
import {
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Extend MUI TooltipProps with custom props
interface CustomTooltipProps extends TooltipProps {
  tooltipMessage: string;
}

// Styled component wrapper
const StyledTooltip = styled(({ className, title, tooltipMessage, ...props }: CustomTooltipProps) => (
  <Tooltip
    {...props}
    title={
      <div>
        <div style={{ color: "red", fontWeight: 600, marginBottom: 4 }}>
          {title}
        </div>
        <div>{tooltipMessage}</div>
      </div>
    }
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [-100, 8],
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "#333",
    border: "1px solid red",
    boxShadow: theme.shadows[3],
    fontSize: 13,
    whiteSpace: "pre-line",
    maxWidth: 350,
    padding: theme.spacing(1),
  },
}));

export default StyledTooltip;
